import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0759cb44"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "audience-historic-stage" };
const _hoisted_2 = { class: "audience-historic-stage__header" };
const _hoisted_3 = { class: "mb-0" };
import { fetchConnectorsByAudience } from '@/features/AudienceManager/data';
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import AudienceHistoricFilter from './AudienceHistoricFilter.vue';
import AudienceHistoricSkeleton from './AudienceHistoricSkeleton.vue';
import AudienceHistoricTable from './AudienceHistoricTable.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceHistoricStage',
    setup(__props) {
        const store = useStore();
        const activeStepName = computed(() => store.getters['audienceManager/activeStepName']);
        const isLoadingHistoricStage = computed(() => store.getters['audienceManager/isLoadingHistoricStage']);
        const audienceId = computed(() => store.getters['audienceManager/getAudienceId']);
        const connectorsByAudience = ref([]);
        const fetchHistoric = () => {
            store.dispatch('audienceManager/fetchHistoric');
        };
        const fetchConnectors = () => {
            fetchConnectorsByAudience(audienceId.value).then(response => {
                if (response) {
                    connectorsByAudience.value = response.data;
                }
            });
        };
        watch(() => activeStepName.value, newStep => {
            if (newStep === 'historic') {
                fetchHistoric();
                fetchConnectors();
            }
        }, { deep: true, immediate: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isLoadingHistoricStage.value)
                    ? (_openBlock(), _createBlock(AudienceHistoricSkeleton, { key: 0 }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('audiences.historic')), 1),
                            (connectorsByAudience.value)
                                ? (_openBlock(), _createBlock(AudienceHistoricFilter, {
                                    key: 0,
                                    "connectors-by-audience": connectorsByAudience.value
                                }, null, 8, ["connectors-by-audience"]))
                                : _createCommentVNode("", true)
                        ]),
                        _createVNode(AudienceHistoricTable)
                    ], 64))
            ]));
        };
    }
});
